export async function fetchProjects(token: string) {
    const API_URL = process.env.REACT_APP_API_URL;
    const res = await fetch(`${API_URL}/projects`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (!res.ok) {
        // avoid JSON.parse on plain text
        await res.text(); // just read and discard
        throw new Error(`Failed to fetch projects: ${res.status}`);
    }

    return res.json(); // only parse JSON if OK
}